import React from 'react';
import { Link } from 'react-router-dom';
import '../../styles/login-register/login-register.scss';
import Grid from '@material-ui/core/Grid';

import 'react-sticky-header/styles.css';

class Footer extends React.Component {
  render() {
    return (
      <Grid
        container
        alignItems={'center'}
        justify={'center'}
        className={
          this.props.sticked
            ? 'footer-wrapper footer-sticked'
            : 'footer-wrapper'
        }
      >
        <Grid item xs={11} className="footer-root">
          <p className="footer-copyright">
            © {new Date().getFullYear()}. Luminaire Broker. All Rights Reserved.
          </p>
          <div className="footer-links">
            <Link to="/about">About</Link>
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-and-conditions">Terms and Conditions</Link>
            <Link to="/cookies">Cookies</Link>
            <Link to="/faq">FAQ</Link>
            <Link to="/contact">Contact us</Link>
          </div>
        </Grid>
      </Grid>
    );
  }
}

export default Footer;
